import { makeFetchTransport, makeMultiplexedTransport } from '@sentry/vue'
import { FEDERATED_DSN } from './common'

/**
 * In this case, transporter needs to return an array of DSNs to route the error to.
 * Like: [{ dsn: "__CART_DSN__", release: "cart@1.0.0" }];
 * OR [] to default to the SPM-TS dsn.
 *
 *
 * Types are not exposed
 */
export const routeErrorsToFederatedDSN = makeMultiplexedTransport(makeFetchTransport, args => {
  const event = args.getEvent()

  if (event?.extra && FEDERATED_DSN in event?.extra && Array.isArray(event?.extra[FEDERATED_DSN])) {
    return event.extra[FEDERATED_DSN]
  }

  return []
})
